import cx from "classnames";

import { ReactComponent as LogoText } from "./logo-text.svg";
import styles from "./styles.module.css";
import Box from "../Box";
import SpaceliftLogo from "./Logo";

type SpaceliftLogoProps = {
  className?: string;
};

const SpaceliftLogoWithText = ({ className }: SpaceliftLogoProps) => {
  return (
    <Box align="center" className={cx(styles.logoWithTextWrapper, className)}>
      <div className={styles.textWrapper}>
        <LogoText className={styles.logoText} />
      </div>
      <SpaceliftLogo className={cx(styles.logoSymbol)} size="medium" />
    </Box>
  );
};

SpaceliftLogoWithText.displayName = "DS.SpaceliftLogoWithText";

export default SpaceliftLogoWithText;
